import React from "react";
import { Redirect } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard/index";

//Utility
import PageMaintenance from "../pages/Utility/PageMaintenance";
import PagePricing from "../pages/Utility/PagePricing/index";
import Error404 from "../pages/Utility/Error404";
import Error500 from "../pages/Utility/Error500";
import Configuration from "../pages/Catalogs/Configuration/Configuration";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//AuthenticationInner related pages
import PageLogin from "../pages/AuthenticationInner/PageLogin";
import PageConfirm from "../pages/Authentication/PageRegister";
//import userProfile from "../pages/Authentication/user-profile";
import Users from "../pages/Catalogs/Users/Users";
import Profile from "../pages/Catalogs/Users/Profile";

//company
import Company from "../pages/Companies/Company";

import Profiles from "../pages/Profiles/Profiles";
import Permissions from "../pages/Profiles/Permissions/Permissions";

//Catalogs
import Routes from "../pages/Catalogs/Routes/Routes";
import Units from "../pages/Catalogs/Units/Units";
import BranchLines from "../pages/Catalogs/BranchLines/BranchLines";
import Geocercas from "../pages/Catalogs/Geofences/Geofences";
import Operators from "../pages/Catalogs/Operators/Operators";
import Concesionarios from "../pages/Catalogs/Concesionarios/Concesionarios";

//configuraciones de ruta
import RouteConfigurations from "../pages/RouteConfigurations/RouteConfigurations";

//Salidas
import Salidas from "../pages/Salidas/Salidas";
import SalidasTablero from "../pages/Salidas/TableroPublico/SalidasTablero";
import SalidasConfigurations from "../pages/SalidasConfigurations/SalidasConfigurations";

//Operaciones
import Imprevistos from "../pages/Imprevistos/Imprevistos";
import Attendance from "../pages/Attendance/Attendance";
import QrScaner from "../pages/Attendance/QrScaner";
import Papeletas from "../pages/Operaciones/Papeletas/Papeletas";
import FuelSales from "../pages/Operaciones/FuelSales/FuelSales";
import OtrosEgresos from "../pages/Operaciones/OtrosEgresos/OtrosEgresos";
import AttendanceConcesionarios from "../pages/Operaciones/AttendanceConcesionarios/AttendanceConcesionarios";

//Reports
import SalidasReport from "../pages/Reports/Salidas/SalidasReport";
import ExcesosReport from "../pages/Reports/Excesos/ExcesosReport";
import UnitIncomeReport from "../pages/Reports/UnitIncome/UnitIncomeReport";
import ExpensesUnitFuelReport from "../pages/Reports/ExpensesUnitFuel/ExpensesUnitFuelReport";
import QuemadosReport from "../pages/Reports/Quemados/QuemadosReport";

import PagosAdministrativos from "../pages/Reports/PagosAdministrativos/PagosAdministrativosReport";
import ConfigurationRoute from "../pages/Catalogs/ConfigurationRoute/ConfigurationRoute";
import Deposits from "../pages/Operaciones/Deposits/Deposits";
import Nomina from "../pages/Operaciones/Nomina/Nomina";
import SalidasPorUnidadReport from "../pages/Reports/SalidasPorUnidad/SalidasPorUnidadReport";
import CombustiblePorUnidadReport from "../pages/Reports/CombustiblePorUnidad/CombustiblePorUnidadReport";
import AsistenciaPorUnidadReport from "../pages/Reports/AsistenciaPorUnidad/AsistenciaPorUnidadReport";
import BaseArrivedReport from "../pages/Reports/BaseArrived/BaseArrivedReport";
import DepositsReport from "../pages/Reports/Deposits/Deposits";
import SalidasDashboard from "../pages/Public/SalidasDashboard/SalidasDashboard";
import FacturacionReport from "../pages/Reports/Facturacion/Facturacion";
import FacturacionAdminReport from "../pages/Reports/FacturacionAdmin/FacturacionAdmin";
import Plans from "../pages/Plans/Plans";
import CumplimientoVeladas from "../pages/Reports/CumplimientoVeladas/CumplimientoVeladas";
import UserDashboard from "../pages/Public/UserDashboard";
import DashboardBia from "../pages/Dashboard BIA";
import AttendanceGraph from "../pages/Graphics/Attendance/AttendanceGraph";
import DeparturesGraph from "../pages/Graphics/Departures/DeparturesGraph";
import MinutesBurnedGraph from "../pages/Graphics/MinutesBurned/MinutesBurnedGraph";
import PassengersGraph from "../pages/Graphics/Passengers/PassengersGraph";
import VeladasGraphWrapper from "../pages/Graphics/Veladas/VeladasGraphWrapper";
import DashboardSalidas from "../pages/Dashboard/dashboardSalidas";
import ValidateEmail from "../pages/Public/ValidateEmail/ValidateEmail";
import DashboardSwitcher from "../pages/Dashboard/DashboardSwitcher";
import ConfigurationNotifications from "../pages/Catalogs/ConfigurationNotifications/ConfigurationNotifications";
import RealtimeTicketPrices from "../pages/RealtimeTicketPrices/RealtimeTicketPrices";
import AsistenciaPorOperadorReport from '../pages/Reports/AsistenciaPorOperador/AsistenciaPorOperadorReport';
import PasajePorUnidadReport from "../pages/Reports/PasajePorUnidad/PasajePorUnidadReport";
import Pasajeros from "../pages/Catalogs/Pasajeros/Pasajeros";
import Vencimientos from "../pages/Reports/Vencimientos/Vencimientos";

const userRoutes = [
  //dashboard
  { path: "/dashboard", component: DashboardSwitcher },
  { path: "/dashboard-salidas", component: DashboardSalidas },
  {
    path: "/dashboard-realtime-ticket-prices",
    component: RealtimeTicketPrices,
  },

  //List_Users Routes
  { path: "/users", component: Users, policy: "users", permission: "all" },
  { path: "/users/profile/:id", component: Profile, policy: "profilePers" },

  //ProfilesPremissons

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },

  /**Catalogos de sistema**/
  { path: "/companies", component: Company, policy: "companies" },
  { path: "/plans", component: Plans, policy: "companies" },
  {
    path: "/configuration/:id?",
    component: Configuration,
    policy: "configuration",
    permission: "all",
  },
  {
    path: "/configuration-route",
    component: ConfigurationRoute,
    policy: "configuration",
    permission: "all",
  },
  {
    path: "/configuration-notifications",
    component: ConfigurationNotifications,
    policy: "configuration",
    permission: "all",
  },
  { path: "/profiles", component: Profiles, policy: "companies" },
  { path: "/profile/:id", component: Permissions, policy: "companies" },
  { path: "/routes", component: Routes, policy: "routes" },
  { path: "/units", component: Units, policy: "units" },
  { path: "/ramales", component: BranchLines, policy: "branch_geo" },
  { path: "/geocercas", component: Geocercas, policy: "branch_geo" },
  { path: "/operators", component: Operators, policy: "operators" },
  { path: "/Concesionarios", component: Concesionarios, policy: "operators" },
  { path: "/pasajeros", component: Pasajeros, policy: "operators" },

  /*Configuracion de rutas*/
  { path: "/routes/:id", component: RouteConfigurations, policy: "routes" },

  /**Salidas**/
  { path: "/salidas", component: Salidas, policy: "salidas" },
  {
    path: "/salidas/configurations",
    component: SalidasConfigurations,
    policy: "salidas",
    permission: "all",
  },
  /********operaciones********/
  { path: "/imprevistos", component: Imprevistos, policy: "improvistos" },
  
  {
    path: "/asistencia",
    component: Attendance,
    policy: "operators",
    permission: "all",
  },
  {
    path: "/asistencia/qrScan",
    component: QrScaner,
    policy: "operators",
    permission: "all",
  },
  {
    path: "/papeletas",
    component: Papeletas,
    policy: "operators",
    permission: "create",
  },
  { path: "/ventas_combustible", component: FuelSales, policy: "sales" },
  { path: "/egresos-otros", component: OtrosEgresos, policy: "sales" },
  {
    path: "/asistencia-concesionario",
    component: AttendanceConcesionarios,
    policy: "operators",
    permission: "all",
  },
  { path: "/depositos", component: Deposits, policy: "sales" },
  { path: "/nominas", component: Nomina, policy: "reports" },

  /********Reportes********/
  /**Salidas**/
  { path: "/reporte/salidas", component: SalidasReport, policy: "reports" },
  {
    path: "/reporte/salidas-unidad",
    component: SalidasPorUnidadReport,
    policy: "reports",
  },
  {
    path: "/reporte/pasaje-unidad",
    component: PasajePorUnidadReport,
    policy: "reports",
  },
  /**Excesos**/
  {
    path: "/reporte/excesos",
    component: ExcesosReport,
    policy: "reports",
    permission: "all",
  },
  /**ingresos unidades**/
  {
    path: "/reporte/ingresos-unidades",
    component: UnitIncomeReport,
    policy: "reports",
    permission: "view",
  },
  /**Egresos de combustible**/
  {
    path: "/reporte/egresos-combustible",
    component: ExpensesUnitFuelReport,
    policy: "reports",
    permission: "view",
  },
  {
    path: "/reporte/gasolina-unidad",
    component: CombustiblePorUnidadReport,
    policy: "reports",
    permission: "view",
  },
  {
    path: "/reporte/egresos-otros/:report",
    component: OtrosEgresos,
    policy: "reports",
    permission: "view",
  },
  /**Quemados**/
  {
    path: "/reporte/quemadas/:report",
    component: QuemadosReport,
    policy: "reports",
    permission: "all",
  },
  //PagosAdministrativos
  {
    path: "/reporte/pagos/administrativos",
    component: PagosAdministrativos,
    policy: "reports",
    permission: "all",
  },

  {
    path: "/reporte/asistencias-operador",
    component: AsistenciaPorOperadorReport,
    policy: "reports",
    permission: "all",
  },

  {
    path: "/reporte/asistencias-unidad",
    component: AsistenciaPorUnidadReport,
    policy: "reports",
    permission: "all",
  },

  {
    path: "/reporte/llegada-base",
    component: BaseArrivedReport,
    policy: "reports",
    permission: "all",
  },
  {
    path: "/reporte/depositos",
    component: DepositsReport,
    policy: "reports",
    permission: "all",
  },
  {
    path: "/reporte/facturacion",
    component: FacturacionReport,
    policy: "reports",
    permission: "all",
  },
  {
    path: "/reporte/facturacion-admin",
    component: FacturacionAdminReport,
    policy: "reports",
  },
  {
    path: "/reporte/cumplimiento-veladas",
    component: CumplimientoVeladas,
    policy: "reports",
  },
  {
    path: "/reporte/vencimientos",
    component: Vencimientos,
    policy: "reports",
  },

  { path: "/rt-bia", component: DashboardBia, policy: "salidas" },

  //Graficas
  {
    path: "/graficas/asistencia",
    component: AttendanceGraph,
    policy: "graphics",
    permission: "all",
  },
  {
    path: "/graficas/salidas",
    component: DeparturesGraph,
    policy: "graphics",
    permission: "all",
  },
  {
    path: "/graficas/min-quemados",
    component: MinutesBurnedGraph,
    policy: "graphics",
    permission: "all",
  },
  {
    path: "/graficas/pasajeros",
    component: PassengersGraph,
    policy: "graphics",
    permission: "all",
  },
  {
    path: "/graficas/veladas",
    component: VeladasGraphWrapper,
    policy: "graphics",
    permission: "all",
  },
];

const authRoutes = [
  //authencation page
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },

  //AuthenticationInner pages
  { path: "/page-login", component: PageLogin },
  { path: "/verifyMail/:id/:token/:reset?", component: PageConfirm },

  //tablero de salidas publico
  { path: "/tablero/:url_route", component: SalidasTablero },

  //Utility page
  { path: "/pages-maintenance", component: PageMaintenance },
  { path: "/pages-404", component: Error404 },
  { path: "/pages-500", component: Error500 },
  { path: "/dashboard/:route_slug", component: SalidasDashboard },
  { path: "/dash-user/:route_slug", component: UserDashboard },
  { path: "/validate/:type/:id/email/:token", component: ValidateEmail },

  //{ path: "*", component: Error404 },
];

const error = { path: "*", component: Error404 };

export { userRoutes, authRoutes, error };
